<template>
  <div class="data-detail p-4">
    <article class="title position-relative">
      <img
        :src="require('../../assets/img/character-typing-cat.png')"
        alt="공놀이하는 고양이 캐릭터 일러스트"
        class="character-header position-absolute bottom-0 right-0  mt-md-0"
      />
      <b-button
        variant="transparant"
        class="p-0 border-0 mt-2 d-md-none"
        @click="$router.go(-1)"
      >
        <i class="icon icon-20 icon-arr-left mb-n1"></i>
        <span class="text-lg-14">
          뒤로가기
        </span>
      </b-button>
      <section class="mt-2 mt-md-4">
        <h1 class="text-lg-24 lh-160 break-keep">{{ currentData.title }}</h1>
      </section>
      <section class="info">
        <ul class="list-unstyled text-grey-light py-2">
          <li>{{ currentData.createdAt }}</li>
        </ul>
      </section>
    </article>
    <hr />
    <section class="desc my-5 py-3 pr-5" v-html="currentData.desc"></section>
    <hr />
    <section class="files">
      <a
        class="btn btn-secondary px-3 rounded-pill"
        role="button"
        :href="`${currentData.files}`"
        target="_blank"
      >
        <i class="icon icon-sm-20 icon-20 icon-file mb-n1 mr-1"></i>
        파일 다운로드
      </a>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index: this.$route.path.split("/")[2],
      allDataRoom: []
    };
  },
  computed: {
    currentData() {
      return this.allDataRoom.find(r => r._id == this.index);
    }
  },
  methods: {
    loadAllDataroom() {
      this.$db
        .collection("allDataRoom")
        .get()
        .then(querySnapshot => {
          const arr = [];
          querySnapshot.forEach(doc => {
            const temp = doc.data();
            temp._id = doc.id;
            arr.push(temp);
          });
          this.allDataRoom = arr.sort(function(a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
        });
    }
  },
  mounted() {
    this.loadAllDataroom();
  }
};
</script>

<style scoped>
.data-detail {
  min-height: 100vh;
}
.character-header {
  margin-bottom: -4rem;
  width: 12rem !important;
  height: auto !important;
  max-width: 30%;
}

@media all and (min-width: 1024px) {
  .desc /deep/ img,
  .desc /deep/ iframe,
  .desc /deep/ video {
    width: inherit !important;
    padding: 2rem 0;
  }
}

.desc /deep/ h1,
.desc /deep/ h2,
.desc /deep/ h3,
.desc /deep/ h4,
.desc /deep/ h5,
.desc /deep/ h6,
.desc /deep/ p {
  padding-right: 5%;
  word-break: keep-all;
  line-height: 1.9;
}
</style>
